/**
 * Human label for an internal enum value (API/backend stable).
 * @param {(path: string) => string} t - useApp().t
 * @param {string} prefix - e.g. 'leaveTypes', 'expenseCategories'
 * @param {string} [value]
 * @returns {string}
 */
export function enumLabel(t, prefix, value) {
  if (value == null || value === '') return '—';
  const key = `${prefix}.${value}`;
  const label = t(key);
  return label === key ? String(value) : label;
}

export const LEAVE_TYPE_VALUES = ['vacation', 'sick', 'study', 'personal', 'remote', 'other'];

export const EXPENSE_CATEGORY_VALUES = ['travel', 'meals', 'office', 'training', 'health', 'equipment', 'other'];

export const EMPLOYMENT_TYPE_VALUES = ['full_time', 'part_time', 'contractor', 'intern'];

export const EMPLOYEE_STATUS_VALUES = ['active', 'onboarding', 'inactive', 'offboarding'];

export const PF_TX_TYPE_VALUES = ['income', 'expense'];
